import * as moment from 'moment';

/**
 * Converte data/hora ISO (UTC) do servidor para horário do Brasil (UTC-3)
 * e formata como DD/MM/YYYY HH:mm:ss.
 * Uso: exibição em telas que devem mostrar horário normalizado para o Brasil.
 * Garante interpretação como UTC (anexa 'Z' se o interceptor tiver removido).
 */
export function formatarDataHoraBR(s: string | null | undefined): string {
  if (!s) return '–';
  try {
    const str = typeof s === 'string' && /T\d{2}:\d{2}/.test(s)
      ? s.replace(/Z$/i, '') + 'Z'
      : s;
    const m = moment.utc(str).subtract(3, 'hours');
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : String(s);
  } catch {
    return String(s);
  }
}
